import { Modal, ModalProps } from '@chakra-ui/react';

Modal.defaultProps = {
  isCentered: true,
  motionPreset: 'slideInBottom',
  scrollBehavior: 'inside',
} as ModalProps;

export default Modal;
